module.exports = __webpack_public_path__ + "img/FinBankBillable.fc279e50.svg";